import { MessageCircle } from "lucide-react";
import { useLocation } from "wouter";

const COMMUNITY_LINK = "https://chat.whatsapp.com/CaaXOZEec4DFG08cFHbuCP";

export default function FloatingWhatsApp() {
  const [location] = useLocation();

  // Hide on homepage, browse pages (where it distracts from search), and pages with prominent WhatsApp CTAs
  if (
    location === "/" ||
    location === "/products" ||
    location.startsWith("/categories") ||
    location.match(/^\/products\/\d/) ||
    location.startsWith("/vendor/dashboard") ||
    location.startsWith("/checkout") ||
    location === "/vendors" ||
    location.startsWith("/vendors/") ||
    location.startsWith("/v/")
  ) {
    return null;
  }

  const link = COMMUNITY_LINK;

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 md:bottom-6 right-4 z-30 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 flex items-center justify-center no-underline"
      aria-label="Chat with Voom on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
